const PAYROLL_LOAN_RECORD_STATUS = {
    /**
     * Payroll Loan Status
     */
    APORTAR_DOC: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: __CONTACT_CENTER__
                    ? "payrollLoanRecordStatus-documentsNotUploadedMessage"
                    : "payrollLoanRecordStatus-uploadDocumentsMessage",
            },
            {
                text: __CONTACT_CENTER__
                    ? "payrollLoanRecordStatus-daysToCompleteFormalFormat"
                    : "payrollLoanRecordStatus-daysToComplete",
                className: "product-banner-header__message-bold",
            },
        ],
        button: {
            text: __CONTACT_CENTER__
                ? "payrollLoanRecordStatus-reviewNeededDocumentation"
                : "payrollLoanRecordStatus-uploadDocuments",
            link: "/myprofile/loans-mortgages/request-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
    },
    APROBADO: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-endedOK",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-contractButton",
            link: "/myprofile/loans-mortgages/contract-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
        analyticsTag: "contratacion",
        analyticsTagV2Button: {
            categoriaEvento:"solicitud aprobada prestamo",
            accionEvento: "clickButton",
            etiquetaEvento: "continuar solicitud",
            nombreProducto: "prestamo personal",
        },
        analyticsTagV2Cancel: {
            categoriaEvento:"solicitud aprobada prestamo",
            accionEvento: "clickLink",
            etiquetaEvento:"cancelar solicitud",
            nombreProducto: "prestamo personal",
        },
        analyticsTagView: {
            categoriaEvento:"solicitud aprobada prestamo",
            accionEvento: "vista",
            etiquetaEvento: "prestamo aprobado",
            nombreProducto: "prestamo personal",
        },
    },
    DENEGADO: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-rejectedLoan",
            },
            {
                text: "payrollLoanRecordStatus-rejectedMoreInfo",
                className:
                    "product-banner-header__message-bold product-banner-header__more-info-message",
            },
        ],
        checkFlag: true,
    },
    DENEGADO_TRAS_APROB: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-deniedByDocumentation",
        messages: [
            {
                text: "payrollLoanRecordStatus-deniedByDocumentationSubtitle",
            },
            {
                text: "payrollLoanRecordStatus-deniedByDocumentationMoreInfo",
                className:
                    "product-banner-header__message-bold product-banner-header__more-info-message",
            },
        ],
        checkFlag: true,
    },
    DENEGADO_TRAS_PREAPROB: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-deniedByDocumentation",
        messages: [
            {
                text: "payrollLoanRecordStatus-deniedByDocumentationSubtitle",
            },
            {
                text: "payrollLoanRecordStatus-deniedByDocumentationMoreInfo",
                className:
                    "product-banner-header__message-bold product-banner-header__more-info-message",
            },
        ],
        checkFlag: true,
    },
    DOC_PTE_VALIDAR: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-validatingDocuments",
            },
        ],
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-ghost" },
        },
        analyticsTagView: {
            categoriaEvento: "solicitud pendiente de validacion prestamo",
            accionEvento: "vista",
            etiquetaEvento: "pendiente de validacion",
            nombreProducto: "prestamo personal",
        },
        analyticsTagV2Cancel: {
            categoriaEvento: "solicitud pendiente de validacion prestamo",
            accionEvento: "clickLink",
            etiquetaEvento: "cancelar solicitud",
            nombreProducto: "prestamo personal",
        },
    },
    ERROR_DOCUMENTACION: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-documentProblem",
            },
            {
                text: "payrollLoanRecordStatus-daysToComplete",
                className:
                    "product-banner-header__message-bold product-banner-header__subtitle-color",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-reviewDocuments",
            link: "/myprofile/loans-mortgages/request-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
    },
    KO_DTI: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-continueWithYourProcess",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-continueRequest",
            link: "/myprofile/loans-mortgages/request-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
    },
    MEJOR_OFERTA: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-endedOK",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-contractButton",
            link: "/myprofile/loans-mortgages/contract-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
    },
    NUEVA_OFERTA: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-weHaveANewOffer",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-checkNewOffering",
            link: "/myprofile/loans-mortgages/contract-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
    },
    PRE_APROB: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-simulationMessage",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-continueRequest",
            link: "/myprofile/loans-mortgages/request-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
    },
    SIMUL: {
        title: {
            icon: "rebrand-loans",
            text: "payrollLoanRecordStatus-title",
        },
        subtitle: "payrollLoanRecordStatus-inProcess",
        messages: [
            {
                text: "payrollLoanRecordStatus-simulationMessage",
            },
        ],
        button: {
            text: "payrollLoanRecordStatus-continueRequest",
            link: "/myprofile/loans-mortgages/request-payroll-loan/",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            styles: { modifier: "link-emphasize" },
        },
        analyticsTag: "simulacion",
        analyticsTagV2Button: {
            categoriaEvento: "solicitud prestamo",
            accionEvento: "click",
            etiquetaEvento: "subir documentacion",
            nombreProducto: "prestamo personal",
        },
        analyticsTagV2Cancel: {
            categoriaEvento: "solicitud prestamo",
            accionEvento: "click",
            etiquetaEvento: "cancelar solicitud",
            nombreProducto: "prestamo personal",
        },
        analyticsTagView: {
            categoriaEvento: "solicitud prestamo",
            accionEvento: "vista",
            etiqueta: "proceso en curso - subir documentacion",
            nombreProducto: "prestamo personal",
        },
    },

    /**
     * Ares Loan Status
     */
    WAIT_RNC_DATA: {
        title: {
            icon: "rebrand-loans",
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansSubTitle",
        },
        subtitle:
            "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription01",
        messages: [
            {
                text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription02",
            },
            {
                text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription03",
                className: "product-banner-header__message-bold",
            },
        ],
        button: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.continueButton",
            link: "/myprofile/loans-mortgages/ares-contract",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.cancelLink",
            styles: { modifier: "link-emphasize" },
        },
        analyticsTagV2Button: {
            accionEvento: "aceptar consentimientos",
            etiquetaEvento: "continuar",
        },
        analyticsTagV2Cancel: {
            accionEvento: "aceptar consentimientos",
            etiquetaEvento: "cancelar solicitud",
        },
    },
    STANDBY: {
        title: {
            icon: "rebrand-loans",
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansSubTitle",
        },
        messages: [
            {
                text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription04",
            },
        ],
        notInterestedButton: true,
        notInterestedButtonConfig: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.cancelGhostLink",
            styles: { modifier: "link-ghost" },
        },
        analyticsTagV2Cancel: {
            accionEvento: "validando documentacion",
            etiquetaEvento: "cancelar solicitud",
        },
    },
    APPROVED: {
        title: {
            icon: "rebrand-loans",
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansSubTitle",
        },
        subtitle:
            "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription05",
        messages: [
            {
                text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription06",
            },
        ],
        button: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.contractButton",
            link: "/myprofile/loans-mortgages/contract-ares-loan",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.cancelLink",
            styles: { modifier: "link-emphasize" },
        },
        analyticsTagV2Button: {
            accionEvento: "solicitud aprobada",
            etiquetaEvento: "contratar",
        },
        analyticsTagV2Cancel: {
            accionEvento: "solicitud aprobada",
            etiquetaEvento: "cancelar solicitud",
        },
    },
    M2_COUNTEROFFER: {
        title: {
            icon: "rebrand-loans",
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansSubTitle",
        },
        subtitle:
            "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription07",
        messages: [
            {
                text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription08",
            },
        ],
        button: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.seeOfferButton",
            link: "/myprofile/loans-mortgages/contract-ares-loan",
        },
        notInterestedButton: true,
        notInterestedButtonConfig: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.cancelLink",
            styles: { modifier: "link-emphasize" },
        },
        analyticsTagV2Button: {
            accionEvento: "contraoferta",
            etiquetaEvento: "ver oferta",
        },
        analyticsTagV2Cancel: {
            accionEvento: "contraoferta",
            etiquetaEvento: "cancelar solicitud",
        },
    },
    WAIT_DOCUMENTS: {
        title: {
            icon: "rebrand-loans",
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansSubTitle",
        },
        messages: [
            {
                text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.personalLoansDescription09",
            },
        ],
        notInterestedButton: true,
        notInterestedButtonConfig: {
            text: "aresLoan-mbBanking.products.loansAndMortgages.productInformation.loansAndMortgagesInformation.mbLoansAndMortgagesInformation.cancelGhostLink",
            styles: { modifier: "link-ghost" },
        },
        analyticsTagV2Cancel: {
            accionEvento: "validando documentacion",
            etiquetaEvento: "cancelar solicitud",
        },
    },
};

module.exports = PAYROLL_LOAN_RECORD_STATUS;
